import { __ } from '@wordpress/i18n'

export default {
  contact: __('ANSPRECHPARTNER', 'dhsv_theme'),
  linkTitle: __('React is working in plugin :)', 'dhsv_theme'),
}
